// extracted by mini-css-extract-plugin
export var actionButton = "_g6-0";
export var fileInput = "_g6-2";
export var paperclip = "_g6-1";